import initialState from './initial-state';

export default (state = initialState, action) => {
    if (!action || !action.type) return state;
    switch (action.type) {
        case 'PERSONALISATION/SET_BRANDS':
            return {
                ...state,
                brands: {
                    ...state.brands,
                    items: action.items,
                    status: action.status
                }
            };
        case 'PERSONALISATION/FETCH_BRANDS_STATUS':
            return {
                ...state,
                brands: {
                    ...state.brands,
                    status: action.status
                }
            };
        case 'PERSONALISATION/SET_SEARCHES':
            return {
                ...state,
                searches: {
                    ...state.searches,
                    items: action.items,
                    status: action.status
                }
            };
        case 'PERSONALISATION/FETCH_SEARCHES_STATUS':
            return {
                ...state,
                searches: {
                    ...state.searches,
                    status: action.status
                }
            };
        case 'RECENT_SEARCHES_LAST_UPDATED':
            return {
                ...state,
                recentSearches: {
                    lastUpdated: action.lastUpdated
                }
            };
        default:
            return state;
    }
};
